import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import "./Upload.css";
import UploadBlue from "../../../assets/upload-blue.svg";
import UploadRed from "../../../assets/upload-red.svg";
import FileIcon from "../../../assets/file-image.svg";
import CrossIcon from "../../../assets/cross-icon.svg";
function Upload({ rtl, fileText = "Upload Form", sizeError = "The attached file shouldn’t exceed 1MB", selectFileErrorText = "Please Select a File", fileFormatError = "Please upload a file with the format of bmp, gif, jpe, ipeg, png, jpg, tiff, tif, jfif, doc, docx, pdf, xlsx, msg, xls, txt, csv, rtf only", selectFileHandler, ErrorMessageHandler, selectFileError = false, sizeLimit = 1024, title, fileType = [
    "image/bmp",
    "image/gif",
    "image/jpeg",
    "image/tiff",
    "image/png",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
    "application/vnd.ms-outlook",
    ".msg",
    "text/plain",
    "text/csv",
    "application/rtf",
], }) {
    const [file, setFile] = useState(null);
    const [error, setError] = useState("");
    const dir = rtl ? "float-right" : "float-left";
    useEffect(() => {
        if (selectFileError) {
            setError(selectFileErrorText);
            setFile(null);
            ErrorMessageHandler(selectFileErrorText);
        }
    }, [selectFileError]);
    const handleChange = (e) => {
        let selectedFile = e.target.files[0];
        const fileSize = Math.round(selectedFile.size / 1024);
        if (fileSize > sizeLimit) {
            setError(sizeError);
            ErrorMessageHandler(sizeError);
            setFile(null);
        }
        else if (!selectedFile) {
            setError(selectFileErrorText);
            ErrorMessageHandler(selectFileErrorText);
            setFile(null);
        }
        else if (selectedFile.type === "") {
            const index = selectedFile.name.lastIndexOf(".");
            const type = selectedFile.name.substring(index);
            if (fileType.includes(type)) {
                setError("");
                setFile(selectedFile);
                selectFileHandler(e, selectedFile);
                ErrorMessageHandler("");
            }
            else {
                setError(fileFormatError);
                ErrorMessageHandler(fileFormatError);
                setFile(null);
            }
        }
        else if (!fileType.includes(selectedFile.type)) {
            setError(fileFormatError);
            ErrorMessageHandler(fileFormatError);
            setFile(null);
        }
        else {
            setError("");
            setFile(selectedFile);
            selectFileHandler(e, selectedFile);
            ErrorMessageHandler("");
        }
    };
    const handleCross = (e) => {
        setFile(null);
        selectFileHandler(e, null);
        setError(selectFileErrorText);
        ErrorMessageHandler(selectFileErrorText);
    };
    const srcImg = error === "" ? UploadBlue : UploadRed;
    const errorLabel = error === "" ? "noErrorLabel" : "errorLabel";
    const errorText = error === "" ? "noErrorText" : "errorText";
    const UploadFileRight = () => {
        return (_jsxs(_Fragment, { children: [_jsxs("label", Object.assign({ className: `upload-label ${errorLabel}` }, { children: [_jsx("input", { type: "file", name: title, onChange: handleChange }), _jsxs("div", Object.assign({ className: "upload-img-content" }, { children: [_jsx("img", { src: srcImg, alt: "upload-icon", className: "upload-file-icon" }), _jsx("p", Object.assign({ className: `upload-file-content sansFont ${errorText}` }, { children: fileText }))] }))] })), file && (_jsxs("div", Object.assign({ className: "upload-file" }, { children: [_jsx("img", { src: FileIcon, alt: "file-icon" }), _jsx("div", Object.assign({ className: "upload-file-text sansFont" }, { children: file.name })), _jsx("img", { src: CrossIcon, alt: title, className: "upload-file-clear-btn", onClick: handleCross })] })))] }));
    };
    // const UploadFileLeft = () => {
    //     return (
    //         <>
    //             {file && (
    //                 <div className='upload-file'>
    //                     <img src={CrossIcon} alt={title} className='upload-file-clear-btn' onClick={handleCross} />
    //                     <div className='upload-file-text sansFont'>{file.name}</div>
    //                     <img src={FileIcon} alt='file-icon' />
    //                 </div>
    //             )}
    //             <label className={`upload-label ${errorLabel}`}>
    //                 <input type="file" name={title} onChange={handleChange} />
    //                 <div className='upload-img-content'>
    //                     <img src={srcImg} alt='upload-icon' className='upload-file-icon' />
    //                     <p className={`upload-file-content sansFont ${errorText}`}>{fileText}</p>
    //                 </div>
    //             </label>
    //         </>
    //     )
    // }
    return (_jsxs("div", Object.assign({ className: `${dir}` }, { children: [_jsx("div", Object.assign({ className: "upload" }, { children: _jsx(UploadFileRight, {}) })), error && (_jsx("div", Object.assign({ className: `upload-file-error sansFont ${dir}` }, { children: error })))] })));
}
export default Upload;
